import React from 'react';
import PropTypes from 'prop-types';
import { Alert, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useSelector } from 'react-redux';

const TbdNotice = ({ jobId }) => {
  // Get the TBD list from Redux
  const tbdList = useSelector((state) => state.tbdApi.tbdList);

  // Filter TBDs for the current job
  const jobTbds = tbdList.filter(
    (tbdItem) => String(tbdItem.ProjectID) === String(jobId)
  );

  // If no TBDs, don't render anything
  if (jobTbds.length === 0) {
    return null;
  }

  // Format the TBD tooltip content - one entry per line
  const tooltipContent = jobTbds.map((tbd) => (
    `${tbd.Table} - ${formatColumnName(tbd.ColumnName)}`
  )).join('\n');

  // Create the tooltip component with proper styling
  const renderTooltip = (props) => (
    <Tooltip id="tbd-tooltip" {...props}>
      <div style={{ whiteSpace: 'pre-line', textAlign: 'left' }}>
        <strong>TBD Items:</strong>
        <br />
        {tooltipContent.split('\n').map((line, index) => (
          <span key={index}>
            {line}
            <br />
          </span>
        ))}
      </div>
    </Tooltip>
  );

  return (
    <OverlayTrigger
      placement="bottom"
      overlay={renderTooltip}
    >
      <Alert variant="danger" className="mb-3 d-flex align-items-center">
        <i className="bi bi-exclamation-triangle-fill me-2"></i>
        <span>This job has <strong>{jobTbds.length}</strong> open TBD{jobTbds.length !== 1 ? 's' : ''}</span>
      </Alert>
    </OverlayTrigger>
  );
};

// Helper function to format column name from camelCase
const formatColumnName = (name) => {
  return name
    .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2")
    .replace(/([a-z])([A-Z])/g, "$1 $2");
};

TbdNotice.propTypes = {
  jobId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired
};

export default TbdNotice;